const NotFound = () => (
  <section className="container py-24 md:py-32">
    <p className="surtitre">Erreur 404</p>
    <span className="separateur" />
    <h1 className="heading-hero mt-5 text-foreground">Page introuvable</h1>
    <p className="mt-6 text-base md:text-lg leading-relaxed text-foreground/80">
      La page demandée n'existe pas ou a été déplacée.
    </p>
    <a
      href="/"
      className="mt-8 inline-flex items-center justify-center rounded-sm bg-gradient-fire px-6 py-3.5 text-sm font-bold uppercase text-primary-foreground shadow-fire transition-smooth hover:opacity-95"
    >
      Retour à l'accueil
    </a>
  </section>
);

export default NotFound;
